import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SplitText } from 'gsap/SplitText';
import Swiper, { Navigation, Pagination, FreeMode, Controller, Thumbs, Scrollbar } from 'swiper';
import Accordion from 'accordionjs';

(function ($, root, undefined) {
  'user strict';

  console.log('%cCreated by Konfiture', 'color: #000; padding: 5px 0px 1px; border-bottom:2px solid #1A1A1A;'), console.log('%chttps://konfiture.com', 'color:#ccc');

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

  gsap.config({
    force3D: true,
  });

  Swiper.use([Navigation, Pagination, FreeMode, Controller, Thumbs, Scrollbar]);

  const $body = $('body');

  const scroller = ScrollSmoother.create({
    smooth: 1.25,
    effects: true,
    // normalizeScroll: true,
  });

  if ($(window).width() < 1024) {
    scroller.kill();
  }

  /**
   * Get true viewport height on mobile
   * avoiding calculating address bar height on mobile (chrome, safari...)
   */
  function initHeightVariable() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  /**
   * Modal
   */
  function modalTrigger() {
    $('body').on('click', '[data-trigger-modal]', function (e) {
      e.preventDefault();

      var $target = $('[data-modal="' + $(this).data('trigger-modal') + '"]');

      $target.addClass('--show');

      $body.addClass('modal-is-open');
      scroller.paused(true);
    });
    
    $('.modal__close').on('click', function () {
      $('.modal').removeClass('--show');
      
      $body.removeClass('modal-is-open');
      scroller.paused(false);
    });

    $(document).mouseup(function (e) {
      if (!$('.modal__content').is(e.target) && $('.modal__content').has(e.target).length === 0) {
        $('.modal').removeClass('--show');
        $body.removeClass('modal-is-open');
        scroller.paused(false);
      }
    });
  }

  /**
   * Accordions handler
   * @requires accordionjs
   */
  function accordionHandler() {
    if ( $('[data-accordion]').length > 0 ) {
      $('[data-accordion]').accordionjs({
        slideSpeed: 600,
        closeAble: true,
        activeIndex: false,
      });

      $('[data-accordion]').on('click', function () {
        setTimeout(function() {
          ScrollTrigger.refresh();
        }, 150);
      });
    }
  }

  /**
   * loaderAnim
   * 
   * @requires gsap
   */
  // const loaderTl = gsap.timeline({
  //   repeat: -1,
  //   yoyo: true,
  // });

  // loaderTl.to($('.loader > svg > path:nth-child(2)'), {
  //   x: '.75rem',
  //   ease: 'power1.inOut',
  //   duration: 2,
  // });

  // loaderTl.to($('.loader > svg > path:nth-child(1)'), {
  //   x: '-.75rem',
  //   ease: 'power1.inOut',
  //   duration: 2,
  // }, '<');

  /**
   * onLoadTransition
   * 
   * @requires gsap
   */
  function onLoadTransition() {
    const onloadTl = gsap.timeline();

    if ($('.nc__hero em .split__char').length > 0) {
      gsap.set($('.nc__hero em .split__char'), {
        y: '150%',
        rotate: 20,
      });
    }

    if ($('h1[data-split] .split__char').length > 0) {
      gsap.set($('h1[data-split] .split__char'), {
        y: '150%',
        rotate: 20,
      });
    }

    if ($('.home .nc__hero').length > 0) {
      gsap.set($('.nc__hero .btn'), {
        y: '150%',
        autoAlpha: 0,
      });
    }

    onloadTl.to($('.loader'), {
      autoAlpha: 0,
      ease: 'expo.out',
      duration: 1,
      pointerEvents: 'none',
    });

    if ($('.nc__hero em .split__char').length > 0) {
      onloadTl.to($('.nc__hero em .split__char'), {
        y: '0',
        ease: 'expo.out',
        duration: 1,
        stagger: .01,
        rotate: 0,
      });
    }

    if ($('h1[data-split] .split__char').length > 0) {
      onloadTl.to($('h1[data-split] .split__char'), {
        y: '0',
        ease: 'expo.out',
        duration: 1,
        stagger: .025,
        rotate: 0,
      }, '<.25');
    }
    
    if ($('.home .nc__hero').length > 0) {
      onloadTl.to($('.nc__hero .btn'), {
        y: '0%',
        ease: 'expo.out',
        duration: 1,
        autoAlpha: 1,
      }, '<.25');
    }
  }

  /**
   * Navbar and menu animations
   * @requires gsap
   */
  function navAnimations() {
    // Add class on scroll
    ScrollTrigger.create({
      trigger: '.nc__main',
      start: 'top -' + $('.nc__navbar').outerHeight() + 'px',
      // markers: true,
      onEnter: () => $('.nc__navbar').toggleClass('--scrolled'),
      onLeaveBack: () => $('.nc__navbar').toggleClass('--scrolled'),
    });

    $('body').on('mouseenter', '.wpmm_mega_menu', function (e) {
      gsap.to($(this).find('> a'), {
        color: '#1C1C1C',
        // color: '#8A8A89',
        duration: .15,
        ease: 'expo.out',
      });

      gsap.to($(this).siblings().find('> a'), {
        // color: '#1C1C1C',
        color: '#8A8A89',
        duration: .15,
        ease: 'expo.out',
      });

      gsap.to($('.nc__navbar__overlay'), {
        autoAlpha: 1,
        ease: 'expo.out',
        duration: .8,
      });
    });

    $('body').on('mouseleave', '.wpmm_mega_menu', function (e) {
      gsap.to($(this).siblings().find('> a'), {
        color: '#1C1C1C',
        // color: '#8A8A89',
        duration: .15,
        ease: 'expo.out',
      });

      gsap.to($('.nc__navbar__overlay'), {
        autoAlpha: 0,
        ease: 'expo.out',
        duration: .8,
      });
    });

    // Toggle class on search focus
    $(document).on('focus', '.nc__navbar__search input', function () {
      $('.nc__navbar').addClass('--searchbar-open');
    });

    $(document).on('blur', '.nc__navbar__search input', function () {
      $('.nc__navbar').removeClass('--searchbar-open');
    });

    // Mobile menu
    $(document).on('click', '.nc__navbar__toggle', function () {
      $(this).toggleClass('--active');
      $('body').toggleClass('menu-is-open');
      $('.nc__mobile__nav').toggleClass('--show');
    });

    $('.nc__mobile__nav').css('padding-top', $('.nc__navbar').outerHeight() + 'px');

    $('.nc__mobile__menu').on('click', '.menu-item-has-children', function () {
      $(this).find('.sub-menu').toggleClass('--show');
    });
  }

  /**
   * splitTitles
   * 
   * @requires gsap
   */
  function splitTitles() {
    if ($('[data-split]').length > 0) {
      const splitText = new SplitText($('[data-split]'), {
        type: 'words, chars',
        charsClass: 'split__char',
        wordsClass: 'split__word',
        // linesClass: 'split__line',
        reduceWhiteSpace: true,
      });
    }
  }

  /**
   * defaultOnScrollReveals
   * 
   * @requires gsap
   */
  function defaultOnScrollReveals() {
    if ($('[data-reveal]').length > 0) {

      $('[data-reveal]').each(function () {
        gsap.set($(this).find('.split__char'), {
          y: '150%',
          rotate: 20,
        });

        var revealTl = gsap.timeline({
          scrollTrigger: {
            trigger: this,
            start: 'top 60%',
            // markers: true,
            toggleActions: 'play none none none',
          }
        })
        
        revealTl.to($(this).find('.split__char'), {
          y: '0%',
          ease: 'expo.out',
          duration: 1,
          stagger: .01,
          rotate: 0,
        })
      })
    }
  }


  /**
   * recentProductsSwiper
   * init swiper slider
   * @requires swiper
   */
  function recentProductsSwiper() {
    if ( $('.nc__recent-products').length > 0 ) {
      const recentProducts = new Swiper('.nc__recent-products .swiper', {
        slidesPerView: 1.25,
        spaceBetween: 28,
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
          },
          992: {
            slidesPerView: 3,
          },
        },
      });

      if ($('.nc__recent-products__cat').length > 0) {
        $('.nc__recent-products__cat').on('click', 'a', function (e) {
          e.preventDefault();
          $('.nc__recent-products__cat a').removeClass('--active');
          $(this).addClass('--active');

          $.ajax({
            type: 'POST',
            url: woocommerce_params.ajax_url,
            dataType: 'html',
            data: {
              'action': 'noircarat_recent_products_filter',
              'category': $(this).data('product-cat'),
            },
            beforeSend: function () {
              $('.nc__recent-products').addClass('--loading');

              gsap.to($('.nc__product-loop'), {
                x: '2rem',
                autoAlpha: 0,
                duration: .8,
                ease: 'expo.out',
                stagger: .05,
              });
            },
            complete: function () {
              $('.nc__recent-products').removeClass('--loading');
            },
            success: function (res) {
              $('.nc__recent-products .swiper-wrapper').html(res).show(1000);

              recentProducts.slideTo(0, 0, false);

              gsap.set($('.nc__product-loop'), {
                x: '-2rem',
                autoAlpha: 0,
              });

              gsap.to($('.nc__product-loop'), {
                x: '0rem',
                autoAlpha: 1,
                duration: .8,
                ease: 'expo.out',
                stagger: .05,
                delay: .1
              });
            }
          })
        });
      }
    }
  }

  /**
   * blogPostsSwiper
   * init swiper slider
   * @requires swiper
   */
  function blogPostsSwiper() {
    if  ($('.nc__recent-posts').length > 0 ) {
      const recentsProducts = new Swiper('.nc__recent-posts .swiper', {
        slidesPerView: 1.1,
        freeMode: true,
        breakpoints: {
          768: {
            slidesPerView: 1.5,
          },
          992: {
            slidesPerView: 2.15,
            navigation: {
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            },
          },
        },
      })
    }
  }

  /**
   * reviewsSwiper
   * init swiper slider
   * @requires swiper
   */
  function reviewsSwiper() {
    if  ($('.nc__reviews').length > 0 ) {
      const recentsProducts = new Swiper('.nc__reviews', {
        slidesPerView: 1,
        freeMode: true,
        spaceBetween: 21,
        pagination: {
          el: '.swiper-pagination',
          enabled: true,
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          768: {
            slidesPerView: 1.6,
            pagination: {
              enabled: false,
            },
          },
          992: {
            slidesPerView: 1.6,
          },
        },
      })
    }
  }

  /**
   * singleProduct
   * all single product template scripts
   * @requires swiper
   * @requires gsap
   * @requires ScrollTrigger
   */
  function singleProduct() {
    const thumbsSwiper = new Swiper('.product-thumbs', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      breakpoints: {
        768: {
          spaceBetween: 20
        }
      },
    });

    const productSwiper = new Swiper('.product-images', {
      thumbs: {
        swiper: thumbsSwiper,
      },
      allowTouchMove: false,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        768: {
          allowTouchMove: true,
        }
      },
    });

    $('[data-src-full]').each(function() {
      $(this).parent().zoom({
        url: $(this).attr('data-src-full'),
      });
    });
    
    if ($(window).width() > 992) {
      // Fix product gallery on scroll
      ScrollTrigger.create({
        trigger: '.nc__single-product__wrapper',
        start: 'top top',
        end: 'bottom 80%',
        // markers: true,
        pin: '.nc__single-product__gallery',
        pinSpacer: false,
        pinSpacing: false,
      });
      
      // Fix woocommerce notices wrapper
      // ScrollTrigger.create({
      //   trigger: '.product',
      //   start: '94px 63px',
      //   end: 'bottom 100%',
      //   // markers: true,
      //   pin: '.woocommerce-notices-wrapper__fix',
      //   pinSpacer: false,
      //   pinSpacing: false,
      // });
    }

    // AJAX add to cart
    $(document.body).on('added_to_cart', function() {
      setTimeout(function () {
        $('.added').removeClass('added');
      }, 2000);
    });

    $('form.cart').on('submit', function (e) {
      e.preventDefault();

      var form = $(this);
      form.addClass('--loading');
      // form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0 } });

      var formData = new FormData(form[0]);
      formData.append('add-to-cart', form.find('[name=add-to-cart]').val());

      // Ajax action.
      $.ajax({
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'ace_add_to_cart'),
        data: formData,
        type: 'POST',
        processData: false,
        contentType: false,
        beforeSend: function() {
          $('.single_add_to_cart_button').addClass('--loading');
        }, 
        complete: function (response, status) {
          response = response.responseJSON;

          $('.single_add_to_cart_button').removeClass('--loading');

          if (!response) {
            return;
          }

          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          // Redirect to cart option
          if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
            window.location = wc_add_to_cart_params.cart_url;
            return;
          }

          var $thisbutton = form.find('.single_add_to_cart_button'); //
          //						var $thisbutton = null; // uncomment this if you don't want the 'View cart' button

          // Trigger event so themes can refresh other areas.
          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

          // Remove existing notices
          $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

          // Add new notices
          form.closest('.nc__main').find('.woocommerce-notices-wrapper').append(response.fragments.notices_html);

          if ($(response.fragments.notices_html).hasClass('woocommerce-error')) {
            gsap.set($('.woocommerce-message'), {
              y: '2rem',
            });
  
            gsap.to($('.woocommerce-message'), {
              y: '0rem',
              autoAlpha: 1,
              ease: 'expo.out',
              duration: .6,
              pointerEvents: 'auto',
              onComplete: function() {
                gsap.to($('.woocommerce-message'), {
                  autoAlpha: 0,
                  ease: 'expo.out',
                  duration: .6,
                  delay: 4,
                  pointerEvents: 'auto'
                });
              },
            });
          } else {
            $body.addClass('quickview-open');

            scroller.paused(true);
          }


          // form.unblock();
          form.removeClass('--loading');
        }
      });
    });

    if ( $('.quantity').length > 0 ) {
      $('.quantity input.qty').prop('disabled', true);
    }
  }

  /**
   * taxProductCatPersonnalisation
   * init swiper slider
   * @requires swiper
   */
  function taxProductCatPersonnalisation() {
    if ( $('.nc__custom-made__trigger').length > 0 ) {
      ScrollTrigger.create({
        trigger: '.nc__custom-made__trigger',
        start: 'top top',
        end: 'bottom 100%',
        // markers: true,
        pin: '.nc__custom-made__pictures',
        pinSpacer: false,
        pinSpacing: false,
      });
  
      $('.nc__custom-made article').each(function () {
        let $productSlug = $(this).attr('data-product-slug');
  
        ScrollTrigger.create({
          trigger: this,
          start: 'top center',
          end: 'bottom center',
          // markers: true,
          onEnter: function() {
            $('.nc__custom-made__pictures img').each(function () {
              if ($productSlug === $(this).data('product-image')) {
                $(this).addClass('--show');
              } else {
                $(this).removeClass('--show');
              }
            })
          },
          onEnterBack: function () {
            $('.nc__custom-made__pictures img').each(function () {
              if ($productSlug === $(this).data('product-image')) {
                $(this).addClass('--show');
              } else {
                $(this).removeClass('--show');
              }
            })
          },
        })
      });
    }
  }

  /**
   * productCatArchive
   */
  function productCatArchive() {
    $('.awf-filter-wrapper').on('click', function () {
      $(this).siblings('.awf-filter-wrapper:not([data-taxonomy="availability"])').addClass('awf-collapsed');
    });

    // $('.woocommerce-ordering select').selectWoo({
    //   minimumResultsForSearch: -1,
    // });

    $(document).mouseup(function (e) {
      var filtersForm = $('.awf-filters-form');

      if (!filtersForm.is(e.target) && filtersForm.has(e.target).length === 0) {
        $('.awf-filter-wrapper:not([data-taxonomy="availability"])').addClass('awf-collapsed');
      }
    });

    // Toggle scroll on filter modal open
    $(document).on('click', '.awf-togglable-preset-btn', function () {
      $body.addClass('modal-is-open');
    });

    $(document).on('click', '.awf-togglable-preset-close-btn', function () {
      $body.removeClass('modal-is-open');
    });

    $(document).on('awf_after_ajax_products_update', function() {
      $('.awf-collapsible').addClass('awf-collapsed');
    });

    // Fix filter on scroll
    if($(window).width() > 1024) {
      ScrollTrigger.create({
        trigger: '.nc__products__wrapper',
        start: '2px ' + $('.nc__navbar__content').outerHeight() + 'px',
        end: 'bottom 50%',
        // markers: true,
        pin: '.nc__products__prelist',
        pinSpacing: false,
      });
    } else {
      ScrollTrigger.create({
        trigger: '.nc__products__wrapper',
        start: 'top 100%',
        end: 'bottom 100%',
        // markers: true,
        onLeave: function () {
          gsap.to($('.nc__products__prelist, .awf-togglable-preset-btn'), {
            autoAlpha: 0,
            pointerEvents: 'none',
            // y: $('.nc__products__prelist').outerHeight() + 'px',
            duration: .6,
            ease: 'expo.out',
          });
        },
        onEnterBack: function () {
          gsap.to($('.nc__products__prelist, .awf-togglable-preset-btn'), {
            autoAlpha: 1,
            pointerEvents: 'auto',
            duration: .3,
            ease: 'expo.out',
          });
        }
      });
    }
  }

  /**
   * engagementsFixOnScroll
   * init swiper slider
   * @requires swiper
   */
  function engagementsFixOnScroll() {

    ScrollTrigger.create({
      trigger: '.nc__engagements__process__fix',
      start: 'top top',
      end: 'bottom 100%',
      // markers: true,
      pin: '.nc__engagements__process__images__wrapper',
      pinSpacer: false,
      pinSpacing: false,
    });

    $('.nc__engagements__process__step').each(function () {
      let $productSlug = $(this).attr('data-image');

      console.log($productSlug);
      console.log($(this).data('image'));

      ScrollTrigger.create({
        trigger: this,
        start: 'top 50%',
        end: 'bottom 100%',
        // markers: true,
        onEnter: function() {
          $('.nc__engagements__process__images img').each(function () {
            if ($productSlug === $(this).data('image')) {
              $(this).addClass('--show');
            } else {
              $(this).removeClass('--show');
            }
          })
        },
        onEnterBack: function () {
          $('.nc__engagements__process__images img').each(function () {
            if ($productSlug === $(this).data('image')) {
              $(this).addClass('--show');
            } else {
              $(this).removeClass('--show');
            }
          })
        },
      })
    });
  }

  /**
   * miniCartHandler
   * toggle, update mini-cart
   */
  function miniCartHandler() {
    $('.woocommerce-mini-cart__inner').css('padding-bottom', $('.woocommerce-mini-cart__bottom').outerHeight());
    
    /**
     *  Refresh mini-cart
     */
    $(document).on('click', '.nc__navbar__cart', function (e) {
      e.preventDefault();

      $body.addClass('quickview-open');

      scroller.paused(true);
      
      $.ajax({
        url: woocommerce_params.ajax_url,
        type: 'post',
        data: {
          'action': 'ajax_update_mini_cart'
        },
        success: function (response) {
          $('#mini-cart-container').html(response);
        }
      });
    });
    
    
    /**
     *  Close mini-cart
     */
    $('.nc__cart-quickview .close').on('click', function () {
      $body.removeClass('quickview-open');

      scroller.paused(false);
    });
    
    $(document).mouseup(function (e) {
      var cartQuickview = $('.nc__cart-quickview__content');
      
      if (!cartQuickview.is(e.target) && cartQuickview.has(e.target).length === 0) {
        $body.removeClass('quickview-open');
        scroller.paused(false);
      }
    });
  }

  /**
   * Wishlist notices handler
   */
  function wishlistCustomNotices() {
    // Fix notices wrapper on scroll on desktop
    if ($('body').hasClass('page-template-wishlist')) {
      $('.nc__main').prepend('<div class="woocommerce-notices-wrapper --fix"></div>');
    }

    // Fix notices wrapper on scroll on desktop
    if ($(window).width() > 1024) {
      if ($body.hasClass('archive') && $('.nc__products__prelist').length > 0) {
        var startTrigger = $('.nc__navbar__topbar').outerHeight() - 78 + 'px top';
      } else {
        var startTrigger = $('.nc__navbar__topbar').outerHeight() + 'px top';
      }

      if ( $('.woocommerce-notices-wrapper').length > 0 ) {
        ScrollTrigger.create({
          trigger: $('.woocommerce-notices-wrapper').parent(),
          // start: '100px 0px',
          start: startTrigger,
          end: 'bottom 50%',
          // markers: true,
          pin: '.woocommerce-notices-wrapper.--fix',
          pinSpacing: false,
        });
      }
    }

    $(document.body).on('tinvwl_wishlist_ajax_response', function (event, post, data) {
      var dataMsg,
      dataUrl = $(data.msg).find('.tinvwl_button_view').data('url'),
      appendEl;

      if (typeof data.status !== 'undefined' && data.msg.trim().length != 0) {

        $('.woocommerce-notices-wrapper').empty();

        if (data.status === true) {
          if (!$('body').hasClass('page-template-wishlist')) {
            // Successfully added to wishlist
            dataMsg = $(data.msg).find('.tinv-txt').html();

            $('.woocommerce-notices-wrapper').append('<div class="woocommerce-message"><span>' + dataMsg + '</span><a class="button" href="' + dataUrl + '">Voir ma wishlist</a><button class="close" aria-hidden="true"><span></span></button></div>');
          } else {
            // Successfully added to cart -> open mini cart
            $body.addClass('quickview-open');
            scroller.paused(true);
          }
        } else {
          if (!$('body').hasClass('page-template-wishlist')) {
            // Successfully removed from wishlist
            dataMsg = $(data.msg).find('.tinv-txt').html();

            $('.woocommerce-notices-wrapper').append('<div  class="woocommerce-message woocommerce-error" role="alert"><span>' + dataMsg + '</span><a class="button" href="' + dataUrl + '">Voir ma wishlist</a><button class="close" aria-hidden="true"><span></span></button></div>');
          } else {
            // Failed to add to cart
            $('.woocommerce-notices-wrapper').append($(data.content).find('.woocommerce-error'));
          }
        }

        if ($('.woocommerce-message').length > 0) {
          gsap.fromTo($('.woocommerce-message'), {
            y: '2rem',
          }, {
            y: '0rem',
            autoAlpha: 1,
            ease: 'expo.out',
            duration: .6,
            pointerEvents: 'auto',
            onComplete: function () {
              gsap.to($('.woocommerce-message'), {
                // y: '0rem',
                autoAlpha: 0,
                ease: 'expo.out',
                duration: .6,
                delay: 4,
                pointerEvents: 'none',
              })
            }
          });
        }
      }
    });
  }

  /**
   * faqScript
   */
  function faqScript() {
    var yoast = {
      accordion: function () {
        $('.wp-block-yoast-faq-block').find('.schema-faq-question').click(function () {
          //Expand or collapse this panel
          $(this).nextAll('.schema-faq-answer').eq(0).slideToggle(300, function () {
            if ($(this).hasClass('collapse')) {
              $(this).removeClass('collapse');
            }
            else {
              $(this).addClass('collapse');
            }
          });

          //Hide the other panels
          $(".schema-faq-answer").not($(this).nextAll('.schema-faq-answer').eq(0)).slideUp('fast');

          ScrollTrigger.refresh();
        });

        $('.wp-block-yoast-faq-block .schema-faq-question').click(function () {
          $('.wp-block-yoast-faq-block .schema-faq-question').not($(this)).removeClass('collapse');
          if ($(this).hasClass('collapse')) {
            $(this).removeClass('collapse');
          }
          else {
            $(this).addClass('collapse');
          }
          ScrollTrigger.refresh();
        });
      }
    };

    yoast.accordion();
  }

  /**
   * Do stuff on window loaded
   */
  $(window).on('load', function () {
    $('body').addClass('--domReady');

    onLoadTransition();

    setTimeout(function () {
      ScrollTrigger.refresh();
    }, 150);
  });

  /**
   * Do stuff on DOM ready
   */
  $(document).on('ready', function () {
    // loaderAnim();

    initHeightVariable();
    navAnimations();
    splitTitles();
    defaultOnScrollReveals();
    
    miniCartHandler();
    modalTrigger();
    accordionHandler();

    wishlistCustomNotices();

    $(document).on('click', '.woocommerce-notices-wrapper .close', function() {
      gsap.to($(this).closest('.woocommerce-message'), {
        // y: '0rem',
        autoAlpha: 0,
        ease: 'expo.out',
        duration: .6,
        pointerEvents: 'none',
      });
    });

    if ($body.hasClass('home')) {
      recentProductsSwiper();
      blogPostsSwiper();
      reviewsSwiper();
    }

    if ($body.hasClass('single-product')) {
      singleProduct();
      recentProductsSwiper();
      reviewsSwiper();
    }

    if ($body.hasClass('tax-product_cat')) {
      productCatArchive();
      taxProductCatPersonnalisation();
    }

    if ($body.hasClass('page-template-engagements')) {
      engagementsFixOnScroll();
    }

    if ($('.schema-faq').length > 0) {
      faqScript();
    }
  });

})(jQuery, this);